import {Component, Input, OnInit} from '@angular/core';
import {ColDef, ColumnApi, GridApi, GridReadyEvent} from 'ag-grid-community';
import {Sendungsereignisse} from '../../models/sendungsereignisse.model';
import {faCaretDown, faCaretUp} from '@fortawesome/free-solid-svg-icons';
import {AG_GRID_LOCALE_DE} from '../../locale.de';
import {SendungereignisInfoCellComponent} from './sendungereignis-info-cell/sendungereignis-info-cell.component';

@Component({
  selector: 'lib-sendungsereignisse',
  templateUrl: './sendungsereignisse.component.html',
  styleUrls: ['./sendungsereignisse.component.css']
})
export class SendungsereignisseComponent implements OnInit {

  public gridApi: GridApi;
  public gridColumnApi: ColumnApi;
  public columnDef: ColDef[];
  public defaultColDef: ColDef;
  public carretUp = faCaretUp;
  public carretDown = faCaretDown;
  public show: boolean;

  public locale = AG_GRID_LOCALE_DE;

  public isCollapsed: boolean = false;

  @Input() sendungsereignisse: Sendungsereignisse[];


  constructor() {
    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      flex: 1,
      lockPosition: true, cellClass: 'locked-col'
    };

    this.columnDef = [
      {
        field: 'statustyp',
        headerName: 'SE',
      },
      {
        headerName: 'Info',
        cellRendererFramework: SendungereignisInfoCellComponent,
        maxWidth: 80
      },
      {
        field: 'statusgrundtyp',
        headerName: 'Substatus',
      },
      {
        field: 'storno',
        headerName: 'Storno'
      },
      {
        field: 'bearbeiter',
        headerName: 'Bearbeiter',
      },
      {
        field: 'wiedereinstreudatum',
        headerName: 'WE',
      },
      {
        valueGetter: this.slicedTime,
        headerName: 'Datum/Zeit',
        sort: 'desc'
      }
    ];
  }

  ngOnInit(): void {
  }

  gridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setRowData(this.sendungsereignisse);
  }

  slicedTime(params: any) {
    return params.data?.zeitpunkt?.slice(0, 16);
  }
}
